import { formatMoneyCompact } from './money';

// Chart colours: each category keeps the same colour on every chart and every visit
export const CHART_PALETTE = [
  '#0288d1', // blue
  '#2e7d32', // green
  '#ed6c02', // orange
  '#9c27b0', // purple
  '#d32f2f', // red
  '#00897b', // teal
  '#5d4037', // brown
  '#c2185b', // pink
  '#455a64', // blue grey
  '#f9a825', // amber
  '#3949ab', // indigo
  '#6d4c41', // dark brown
  '#7cb342', // light green
  '#00acc1', // cyan
];

const hash = (text) => {
  let h = 0;
  for (let i = 0; i < text.length; i++) {
    h = (h * 31 + text.charCodeAt(i)) >>> 0;
  }
  return h;
};

/** The colour for a category (or group, account ...) name */
export const colorFor = (name) => CHART_PALETTE[hash(String(name || '')) % CHART_PALETTE.length];

/** Short amounts for chart axes in the user's currency: ₹1.2L / $1.2M */
export const formatMoneyShort = (value) => formatMoneyCompact(value);
